import { PagedData, UUID } from '@ird/shared-base';
import { Manufacturer } from '../brand-management/manufacturer';
import { CountryModel } from '../country';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class ProductionSite {
  id: string;
  name: string;
  city?: string;
  countryId?: string;
  description?: string;
  factoryCode?: string;
  manufacturers?: Array<Manufacturer>;
  serialNumberPatterns?: Array<string>;
  state?: string;
  street?: string;
  zip?: string;
  selected?: boolean;
  country?: CountryModel;
  tenantIds?: Array<UUID>;
  /** Resolved from {@link tenantIds} in the middleware — the backend only returns the ids. */
  tenants?: Array<ProductionSiteTenant>;
}

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export interface ProductionSiteTenant {
  id: UUID;
  name: string;
}

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export interface ProductionSiteSelection {
  productionSiteArray: PagedData<ProductionSite>;
  selectedProductionSitesCount?: number;
  allProductionSitesCount?: number;
}
